import React, { Component } from 'react';
import {CardSmall} from '../../widgets/Cards';
import {connect} from 'react-redux';
import Moment from 'react-moment';


import { fetchHADetails } from '../../../actions';


class HAList extends Component {

    constructor(props) {
            super(props);
            this.state = {
                showModal: false,
                showDelete : false,
                newForm : true,
                record : null,
            };
        };

    //Initial Rendering
    componentDidMount() {
        this.props.fetchHADetails(this.props.patient._id);
    }

    componentDidUpdate(prevProps) {
        if (this.props.patient._id !== prevProps.patient._id) {
                this.props.fetchHADetails(this.props.patient._id)
        }   
    }

    compareDate(a, b) {

        var key1 = a.date;
        var key2 = b.date;
    
        if (key1 > key2) {
            return -1;
        } else if (key1 === key2) {
            return 0;
        } else {
            return 1;
        }
    }

    
    renderHAList() {

        var list = this.props.HAList;
        var sortedList = list.sort(this.compareDate);

        return sortedList.map(ha =>  {

            const rowButton = () => {
                var permit = this.props.selectedPermission.permission[0].chronicdisease;
                if (permit === "View only") {
                    return null;
                } else { 
                    return (
                        <>
                        <button onClick={() => this.setState({showModal: true, newForm: false, record: ha._id})} className='tableEdit'><i className="far fa-edit"></i></button>
                        <button onClick={() => this.setState({showDelete: true, record: ha._id})} className='tableDelete'><i className="fas fa-trash"></i></button>
                        </>
                    )
                }  
            }

            
            return (
                    <tr key={ha._id}>
                        <td><Moment format='DD MMM YYYY'>{ha.date}</Moment></td>
                        <td>{ha.userId}</td>
                     
                        <td>
                            {rowButton()}
                        </td>
                    </tr>
            )
        })
    }

    buttons() {
        var permit = this.props.selectedPermission.permission[0].chronicdisease;
        if (permit === "View only") {
            return null
        } else { 
            return  <button onClick={() => this.setState({showModal: true, newForm: true, record: null})} className='btnew'>Add</button>
        }  
    }

    render() {
        return (
        
                <CardSmall title='Health Assessment List' buttons={this.buttons()}>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Practitioner</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody> 
                            {this.renderHAList()}
                        </tbody> 
                    </table>
                    
                </CardSmall>
        )
    }

}


const mapStateToProps = (state) => {
    return { 
        patient : state.selectedPatient,
        HAList: Object.values(state.ha_details),
        userId : state.auth.userId,
        selectedHADetail : state.selectedHADetail,
        selectedPermission : state.selectedPermission,
    }
}

export default connect(mapStateToProps, {fetchHADetails})(HAList);




/////////////////



  


//     renderModalBox() {
//         const record = this.state.record;
//         if (record !== null) {
//            this.props.fetchTodo(record);
//         }

//         //content of the Modal Box

//         const todoForm = () => {
//             const required = value =>(value ? undefined : 'Required');
         
//             var content;
//             if (this.state.newForm === false ) {
//                 content = this.props.selectedTodo;
//             } else {
//                 content = null;
//             }
//             const currentTodo = content;

//             const handleSubmit = (formValues) => {
            
//                 const form = formValues;
//                 form['patientId'] = this.props.patient._id;
//                 form['userId'] = this.props.userId;  
//                 console.log(form);

//                 const todoId = form._id;
//                 if (todoId === undefined) {
//                     this.props.newTodo(form);
//                 } else {
//                     this.props.editTodo(form, todoId);
//                 }
//                 this.setState({showModal :false, newForm : true,record : null,});
//            }

//             return (
//                 <Form 
//                     onSubmit = {handleSubmit} 
//                     initialValues = {currentTodo}
//                     render = {({ handleSubmit, pristine, form, values, submitting }) => {
//                     return   (
//                             <form onSubmit={handleSubmit}>
//                                     <Field name="reason" component='input' validate={required} placeholder='Enter what todo'>
//                                         {({input, meta, placeholder}) => (
//                                             <div className={meta.active ? 'active':''}>
//                                                 <label>Todo</label>
//                                                 <input {...input} placeholder={placeholder} />
//                                                 {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
//                                             </div>
//                                         )}
//                                     </Field>
//                                     <Field name="duedate" component='input' validate={required} placeholder='Enter content'>
//                                         {({input, meta, placeholder}) => (
//                                             <div className={meta.active ? 'active':''}>
//                                                 <label>Due Date</label>
//                                                 <input type='date' {...input} placeholder={placeholder} />
//                                                 {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
//                                             </div>
//                                         )}
//                                     </Field>
//                                     <Field name="recurring" component='input'>
//                                         {({ input}) => (
//                                             <div>
//                                                 <label>Recurring</label>
//                                                 <select {...input}>
//                                                     <option value="Once only">Once only</option>
//                                                     <option value="Annually">Annually</option>
//                                                     <option value="Every 3 months">Every 3 months</option>
//                                                     <option value="Every 6 months">Every 6 months</option>
//                                                     <option value="Every 2 years">Every 2 years</option>
//                                                     <option value="Every 5 years">Every 5 years</option>
//                                                 </select>
//                                             </div>
//                                     )}
//                                     </Field>
//                                     <Field name='provider'  validate={required}  placeholder='Enter Provider'>
//                                         {({input, meta, placeholder}) => (
//                                                 <div className={meta.active ? 'active':''}>
//                                                     <label>Provider</label>
//                                                     <input {...input} placeholder={placeholder} />
//                                                     {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
//                                                 </div>
//                                             )}
//                                     </Field>       
//                                     <Field name='location'  validate={required}  placeholder='Where is it going to be done'>
//                                         {({input, meta, placeholder}) => (
//                                                 <div className={meta.active ? 'active':''}>
//                                                     <label>Location</label>
//                                                     <input {...input} placeholder={placeholder} />
//                                                     {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
//                                                 </div>
//                                             )}
//                                     </Field>  
//                                     <Field name='datecreated'  validate={required} placeholder='Enter date'>
//                                         {({input, meta}) => (
//                                                 <div className={meta.active ? 'active':''}>
//                                                     <label>Date Created</label>
//                                                     <input {...input} type='date' />
//                                                     {meta.error && meta.touched && <span className={'err'}>{meta.error}</span>}
//                                                 </div>
//                                             )}
//                                     </Field>
//                                     <div className='modalButton'>
//                                         <button type='submit' disabled={submitting || pristine} className='btnew'>Submit</button>
//                                         <button type='button' onClick={form.reset} disabled={submitting || pristine } className='btdel'>Reset</button>
//                                         <button onClick={() => this.setState({showModal: false, record: null})} className='btdel'>Cancel</button>
//                                     </div>
//                             </form>
//                         )
//                     }}
//                 />
//             )
//         }   
//         //  <pre>{JSON.stringify(values, 0, 2)}</pre>

//         return (
//             <Modal 
//                 height='420px'
//                 width='240px'
//                 open={this.state.showModal} 
//                 title='Edit Todo'
//                 data={this.state.record}
//                 content={todoForm()}
//                 onDismiss={() => this.setState({showModal: false, record: null})}
//             />
//         )
//     }

// }










    








